import './TopPart.scss';
import { CountdownAndPayTable } from '../countdown-and-pay-table/CountdownAndPayTable';
import { RoundBalls } from '../round-balls/RoundBalls';
import { observer } from 'mobx-react';
import { roundStore, userStore } from '../../platform/stores';
import { RoundStatus } from '../../platform/enums/round-status';
import { c } from '../../platform/utils';
import burgerMenu from '../../assets/icons/burger-menu.svg';
import { sidebarStore } from '../../platform/stores/sidebarStore';

export const TopPart = observer(() => {
  const { roundStatus } = roundStore;
  const { playerExternalId, balance, currency } = userStore;

  return (
    <>
      <div className="mobile-user-info">
        <div className="flex-center" onClick={() => sidebarStore.setIsOpen(true)}>
          <img src={burgerMenu} alt="Burger menu"/>
        </div>
        <div className="user-info">
          <div className="id">ID {playerExternalId}</div>
          <div className="balance">{c(balance, currency)}</div>
        </div>
      </div>
      <div className="top-part-component">
        <div className="top-part-wrapper">
          <div className="container">
            {
              roundStatus === RoundStatus.Started
                ?
                <CountdownAndPayTable/>
                :
                <RoundBalls/>
            }
          </div>
        </div>
        <div className="top-part-background"></div>
      </div>
    </>
  );
});
